import React, {} from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Example } from 'components';
import i18n from 'i18next';

const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: stretch;
	gap: 20px;
`;

const ExmapleBlockCity = () => {
	const { t } = useTranslation();

	return (
		<>

			<Container>

				<Example url={'https://images.acase.ru/sjas/xmlgw/xsd/CityActionDescriptionRequest.xsd'} title={t('Схема запроса') + ' ' + t('Информация о городе')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/xsd/CityActionDescriptionResponse.xsd'} title={t('Схема ответа') + ' ' + t('Информация о городе')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/xsd/CityActionPubliclistRequest.xsd'} title={t('Схема запроса') + ' ' + t('Список городов')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/xsd/CityActionPubliclistResponse.xsd'} title={t('Схема ответа') + ' ' + t('Список городов')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/CityActionDescriptionRequest.xml'} title={t('Пример запроса') + ' ' + t('Информация о городе')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/CityActionDescriptionResponse.xml'} title={t('Пример успешного ответа') + ' ' + t('Информация о городе')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/CityActionPubliclistRequest.xml'} title={t('Пример запроса') + ' ' + t('Список городов')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/CityActionPubliclistResponse.xml'} title={t('Пример успешного ответа') + ' ' + t('Список городов')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/CityActionPubliclistResponseError.xml'} title={t('Пример ответа с ошибкой')}/>

			</Container>
		</>
	);
};

export default ExmapleBlockCity;